import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUserOrgCase } from '@context/UserOrgCaseContext';
import {
  decodeSearchParams,
  getEffectiveDateRange,
} from '@pages/CaseDashboard/utils';
import { FiltersForm } from '@shared/types/forms';
import { getEndOfTodayDate } from '@utils/dates';

interface UseFiltersInitialDates {
  defaultStartDate: string;
  defaultEndDate: string;
  startDate: string;
  endDate: string;
  isDefaultDateRange: boolean;
}

export const useFiltersInitialDates = (): UseFiltersInitialDates => {
  const [searchParams] = useSearchParams();

  const filters: FiltersForm = decodeSearchParams(searchParams);

  const { selectedCase } = useUserOrgCase();
  const today = useMemo(() => getEndOfTodayDate(), []);

  const { defaultStartDate, defaultEndDate, startDate, endDate } = useMemo(
    () =>
      getEffectiveDateRange(selectedCase, today, {
        startDate: filters.startDate,
        endDate: filters.endDate,
      }),
    [selectedCase, today, filters.startDate, filters.endDate],
  );

  const isDefaultDateRange = useMemo(
    () =>
      !filters.startDate &&
      !filters.endDate &&
      filters.startDate === defaultStartDate &&
      filters.endDate === defaultEndDate,
    [filters.startDate, filters.endDate, defaultStartDate, defaultEndDate],
  );

  return {
    defaultStartDate: defaultStartDate as string,
    defaultEndDate,
    startDate: startDate as string,
    endDate,
    isDefaultDateRange,
  };
};
